import script from "./userLevelUpper.vue?vue&type=script&setup=true&lang=js"
export * from "./userLevelUpper.vue?vue&type=script&setup=true&lang=js"

import "./userLevelUpper.vue?vue&type=style&index=0&id=efd25ed4&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efd25ed4"]])

export default __exports__